import { erpAxios } from '..';

const getRacuniForSelect = async (clientId) => {
  const { data } = await erpAxios.get(`/racuni/getRacuniForSelect/${clientId}`);
  return data;
};

export default getRacuniForSelect;
